export default {
  getTeamDefinitions: state => state.teamDefinitions,
  getFreeTeamDefinitions: state => state.freeTeamDefinitions,
  getTeamDefinitionData: state => state.teamDefinition,
  getChecklistDictionaries: state => state.checklistDictionaries,
  getFreeChecklistDictionaries: state => state.freeChecklistDictionaries,
  getChecklistDictionaryData: state => state.checklistDictionary,
}
